<template>
  <div id="map" ref="map" class="map"></div>
</template>

<script>
import { bd09ToWgs84 } from '@/core/coordTransform'

const MARKER_ICON =
  'data:image/png;base64,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'

// 原百度地图 BD-09 坐标
const BD09_LNG = 117.213604
const BD09_LAT = 29.301144
// 天地图标准底图瓦片最高只到 18 级，超过后无瓦片会显示灰底
const MAP_MIN_ZOOM = 10
const MAP_MAX_ZOOM = 18
const MAP_DEFAULT_ZOOM = 18

export default {
  name: 'map-component',
  props: {},
  data() {
    return {
      map: null
    }
  },
  mounted() {
    this.initMap()
    this.$refs.map.addEventListener('mouseenter', this.enableWheelZoom)
    this.$refs.map.addEventListener('mouseleave', this.disableWheelZoom)
  },
  beforeDestroy() {
    if (this.$refs.map) {
      this.$refs.map.removeEventListener('mouseenter', this.enableWheelZoom)
      this.$refs.map.removeEventListener('mouseleave', this.disableWheelZoom)
    }
    this.map = null
  },
  methods: {
    enableWheelZoom() {
      if (this.map) {
        this.map.enableScrollWheelZoom()
      }
    },
    disableWheelZoom() {
      if (this.map) {
        this.map.disableScrollWheelZoom()
      }
    },
    initMap() {
      const { T } = window
      const [lng, lat] = bd09ToWgs84(BD09_LNG, BD09_LAT)
      const lnglat = new T.LngLat(lng, lat)
      const map = new T.Map(this.$refs.map, {
        minZoom: MAP_MIN_ZOOM,
        maxZoom: MAP_MAX_ZOOM
      })

      map.centerAndZoom(lnglat, MAP_DEFAULT_ZOOM)
      map.setMinZoom(MAP_MIN_ZOOM)
      map.setMaxZoom(MAP_MAX_ZOOM)
      map.enableDoubleClickZoom()
      map.addControl(new T.Control.Zoom())

      const icon = new T.Icon({
        iconUrl: MARKER_ICON,
        iconSize: new T.Point(32, 37),
        iconAnchor: new T.Point(16, 37)
      })
      const marker = new T.Marker(lnglat, { icon })

      map.addOverLay(marker)
      this.map = map

      this.$nextTick(() => {
        map.checkResize()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/css_base.scss';
.map {
  width: 100%;
  height: 100%;
}
</style>
